console.log(process.env.REACT_APP_ENV);

export const API_BASE_URL =
  process.env.REACT_APP_ENV === 'production'
    ? '/api'
    : process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

console.log('API_BASE_URL:', API_BASE_URL);